import { render } from "./dialog.vue?vue&type=template&id=6e7bcc90&scoped=true"
import script from "./dialog.vue?vue&type=script&lang=ts"
export * from "./dialog.vue?vue&type=script&lang=ts"

import "./dialog.vue?vue&type=style&index=0&id=6e7bcc90&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6e7bcc90"

export default script